import React from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import autobind from "class-autobind"
import { IHolidayPaygroupInstance } from "../../../models"
import AccountStore from "../../../stores/AccountStore"
import HolidayPaygroupInstanceDialog from "./HolidayPaygroupInstanceDialog"
interface IProps {
  title: string
  titleStyle: React.CSSProperties
  chipStyle: React.CSSProperties
  addButtonStyle: React.CSSProperties
  holidays: IHolidayPaygroupInstance[]
  error: string
  handleChange(holidays: IHolidayPaygroupInstance[]): void
}
interface IState {
  openHolidayPaygroupInstanceDialog: boolean
}

export default class HolidayTemplatesChip extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      openHolidayPaygroupInstanceDialog: false,
    }
    autobind(this)
  }

  handleDelete(holiday) {
    const holidays = this.props.holidays.slice().filter(item => item.Id !== holiday.Id)
    this.props.handleChange(holidays)
  }

  handleAdd(holiday) {
    this.setState({ openHolidayPaygroupInstanceDialog: false })
    const holidays = this.props.holidays.slice()
    holidays.push(holiday)
    this.props.handleChange(holidays)
  }

  render() {
    return (
      <div style={{ position: "relative" }}>
        <span style={this.props.titleStyle}>{this.props.title}</span>
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: -5 }}>
          {this.props.holidays.map((holiday, index) =>
            <Chip key={index} onRequestDelete={() => this.handleDelete(holiday)} style={this.props.chipStyle}>
              {AccountStore.getCurrentAccount().HolidayTemplates.find(item => item.Id === holiday.HolidayTemplateId).Name}
            </Chip>
          )}
          <div style={this.props.addButtonStyle}>
            {!this.state.openHolidayPaygroupInstanceDialog &&
              <IconButton data-intercom-target={"Btn-OpenHolidayPayGroupInstanceDialog"} onTouchTap={() => this.setState({ openHolidayPaygroupInstanceDialog: true })}>
                <FontIcon className="fa fa-plus-circle" />
              </IconButton>
            }
          </div>
        </div>
        {this.props.error && !this.state.openHolidayPaygroupInstanceDialog &&
          <div style={{ position: "absolute", fontSize: 12, color: "rgb(244, 67, 54)", transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms" }}>
            {this.props.error}
          </div>
        }
        {this.state.openHolidayPaygroupInstanceDialog &&
          <HolidayPaygroupInstanceDialog
            handleClose={() => this.setState({ openHolidayPaygroupInstanceDialog: false })}
            handleSave={holiday => this.handleAdd(holiday)}
          />
        }
      </div>
    )
  }
}